import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export function EstadoVazio({
  icone: Icone,
  titulo,
  descricao,
  acao,
}: {
  icone: LucideIcon;
  titulo: string;
  descricao?: string;
  acao?: ReactNode;
}) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 p-8 text-center">
      <span className="flex size-12 items-center justify-center rounded-full bg-gold-50 text-gold-600">
        <Icone size={22} strokeWidth={1.75} />
      </span>
      <div className="space-y-1">
        <p className="font-display text-lg font-semibold text-neutral-900">{titulo}</p>
        {descricao && <p className="max-w-sm text-sm text-neutral-500">{descricao}</p>}
      </div>
      {acao}
    </div>
  );
}
